import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import "./Dashboard.css";

const DashboardCard = ({ title, value, icon, color }) => {
  const navigate = useNavigate();

  const routeMap = {
    "Establishments": "/building",
    "Shops": "/shops",
    "Merchants": "/merchants",
    "Service Providers": "/serviceProviders",
    "Users": "/systemUsers",
  };

  const handleClick = () => {
    const path = routeMap[title] || "/";
    navigate(path);
  };

  return (
    <div className="dashboard-card interactive-card" onClick={handleClick}>
      <div className="card-icon" style={{ backgroundColor: color }}>
        {icon}
      </div>
      <div className="card-info">
        <div className="card-title">{title}</div>
        <div className="card-count">{value}</div>
        <button className="view-more-btn">
          View Details <ArrowRight size={14} />
        </button>
      </div>
    </div>
  );
};

export default DashboardCard;
